import { fetchProfile } from '@/api/admin-be';
import { defineStore } from 'pinia';
import { catchError } from '@/helpers/toast';

export type UserBetSlip = {
  id: number;
  guid: string;
  preset: null | string;
  userId: number;
  promo: null | string;
  currency: string;
  stakeAmount: string; // Decimal
  maxPayout: string; // Decimal
  vendorCurrency: string;
  vendorStakeAmount: string; // Decimal
  vendorMaxPayout: string; // Decimal
  payout: string; // Decimal
  refund: string; // Decimal
  type: null | 'Single' | 'Multi' | 'System' | 'Chained' | 'Ways';
  status: null | 'Won' | 'Lost';
  rejectStatus: null | 'delayed' | 'rejected';
  rejectionData: null | object;
  parentBetSlipId: number;
  createdAt: string;
  updatedAt: string;
};

export const useProfileStore = defineStore('profile', {
  state: () => ({
    profile: null as UserBetSlip[] | null,
    profileId: null as number | null,
    loading: false,
  }),
  actions: {
    async fetchProfile(id: number) {
      this.loading = true;
      this.profile = await fetchProfile(id)
        .then((data) => {
          this.profileId = id;
          return data;
        })
        .catch((error) => catchError('Ошибка загрузки профиля игрока', error))
        .finally(() => {
          this.loading = false;
        });
    },
  },
});
